// src/components/blog/components/features/ReadingProgress.tsx

'use client'

import type { ReactNode } from 'react'
import { motion, useScroll, useSpring } from 'motion/react'

/**
 * Reading progress indicator component.
 * 
 * Displays a fixed progress bar at the top of the page that fills as the user
 * scrolls through the content. Optimized for performance with Framer Motion's
 * built-in batching and throttling.
 * 
 * @returns {ReactNode} The reading progress bar component
 */
export function ReadingProgress(): ReactNode {
  const { scrollYProgress } = useScroll()
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  })

  return (
    <motion.div
      className="fixed left-0 right-0 bg-indigo-600 dark:bg-indigo-500 origin-left pointer-events-none"
      style={{ 
        top: '152px',
        height: '3px',
        zIndex: 100,
        scaleX
      }}
    />
  )
} 